import { render, staticRenderFns } from "./chartSensor.vue?vue&type=template&id=2279dd1e"
import script from "./chartSensor.vue?vue&type=script&lang=js"
export * from "./chartSensor.vue?vue&type=script&lang=js"
import style0 from "./chartSensor.vue?vue&type=style&index=0&id=2279dd1e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports